export var supportedCurrencies = [
    {
        value: 'EUR',
        label: 'Euro (€)',
    },
    {
        value: 'GBP',
        label: 'Pound sterling (£)',
    },
    {
        value: 'USD',
        label: 'U.S. Dollar ($)',
    },
];
export var supportedLocales = [
    {
        value: 'nl-nl',
        label: 'The Netherlands',
    },
    {
        value: 'en-gb',
        label: 'United Kingdom'
    }
];
